import { cn } from '@/utils/cn';

interface TextPostTileProps {
  /** Caption / title shown as the tile body */
  text?: string | null;
  /** Shown (muted) when there is no text at all */
  emptyLabel: string;
  className?: string;
}

/**
 * Tile for posts without media: the caption snippet on a light surface, so text-only posts do not
 * show a broken-looking image placeholder. Fills its (square) parent.
 */
export const TextPostTile = ({ text, emptyLabel, className }: TextPostTileProps) => {
  const snippet = (text ?? '').trim();
  return (
    <div className={cn('flex h-full w-full items-start overflow-hidden border border-gray-200 bg-gray-50 p-2 sm:p-2.5', className)}>
      {snippet ? (
        <p className="line-clamp-5 break-words text-[10px] leading-snug text-gray-700 sm:text-[11px]">{snippet}</p>
      ) : (
        <p className="text-[11px] italic text-gray-400 sm:text-xs">{emptyLabel}</p>
      )}
    </div>
  );
};
